import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "dashboardview.messagescard.title",
    defaultMessage: "MESSAGES",
    description: "heading for messages card",
  },
});
